import {Link as PeacockLink} from '@pepsico-ds/ui'

/**
 * @typedef {import('@pepsico-ds/ui').ILinkProps} LinkProps
 * @property {boolean} [disabled] When true, link is rendered in disabled mode.
 * @property {boolean} [showIconTrailing] When true, renders a trailing icon after the label.
 * @property {string} [label] Value to display on link (or use children).
 * @property {'large' | 'medium' | 'small' | 'extra-small'} [size] Link size. Defaults to 'medium'.
 * @property {boolean} [useAnchor] When false, renders a `<span>` instead of an `<a>`. Defaults to true.
 * @property {import('@pepsico-ds/ui').ITooltipProps} [tooltip] Tooltip shown on hover.
 * @property {boolean} [skeleton] Renders skeleton state.
 * @property {import('react').MouseEventHandler} [onClick] Click handler.
 * @property {string} ['data-cy'] Optional Cypress test attribute.
 */

/**
 * Wrapper around Peacock DS Link.
 * Supports all Peacock DS link props.
 * @param {LinkProps} props
 */
export const Link = props => {
  return <PeacockLink {...props} />
}
